"use client";

import { useSearchBox } from "react-instantsearch";
import { Search } from "~/components/icons/24/Search";
import { TextField } from "~/components/ui/TextField";
import styles from "./AlgoliaSearchInput.module.css";

export const AlgoliaSearchInput = () => {
	const { query, refine, clear } = useSearchBox();
	return (
		<TextField
			value={query}
			onChange={(e) => {
				refine(e.target.value);
			}}
			className={styles.searchInput}
			classNames={{
				icon: styles.searchIcon,
			}}
			placeholder="Hva ser du etter?"
			icon={<Search />}
			clearIcon={!!query?.trim()}
			onClear={() => {
				clear();
			}}
			autoFocus
		/>
	);
};
